export const FLEXIBLE_TEXT_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.FlexibleTextWidgetElement';
